import { createSelector } from '@reduxjs/toolkit';
import { configSelector } from './slices/config';
import { modulesSelector } from './slices/modules';
import { userSelector } from './slices/user';
import { planDataSelector } from './slices/plan';
import { momentShownPayloadSelector } from './slices/pageData';
// ✅ Fix: Explicitly define return type with `as const`
export const contentDataSelector = createSelector([userSelector, configSelector, modulesSelector, planDataSelector], (user, config, modules, plan) => {
    return {
        user,
        config,
        modules,
        plan,
    }; // ✅ This ensures TypeScript can infer types without exposing `UIState`
}); // ✅ Explicitly cast selector return type
// ✅ Fix: Explicitly define return type with `as const`
export const planActionPayloadSelector = createSelector([planDataSelector, momentShownPayloadSelector], (planData, momentShownPayload) => {
    return {
        ...momentShownPayload,
        externalId: planData.externalId,
    };
}); // ✅ Explicitly cast selector return type
//# sourceMappingURL=selectors.js.map